import { useState } from 'react'
import ProjectCard from "./ProjectCard.jsx";
import ProjectModal from "./ProjectModal";
import './styles/projects.css'
import { PROJECTS } from '../constants.js'
import useReveal from '../hooks/useReveal';


export default function Projects() {
  const [activeProject, setActiveProject] = useState(null);
  const [current, setCurrent] = useState(0);
  const [slideDir, setSlideDir] = useState("");

  const navigate = (dir) => {
    setSlideDir("");
    requestAnimationFrame(() => {
      setSlideDir(dir);
      setCurrent(i =>
        dir === "slide-left"
          ? (i + 1) % PROJECTS.length
          : (i - 1 + PROJECTS.length) % PROJECTS.length
      );
    });
  };
  
  const ref = useReveal();

  return (
    <section ref={ref} id="projects" className="section">
      <h1 className="reveal">{"Projects {"}</h1>

      <div className="carousel reveal">
        <button className="carousel-btn carousel-btn--prev" onClick={() => navigate("slide-right")} aria-label="Previous">
          &lt;
        </button>

        <div className={`carousel-track ${slideDir}`}>
          <ProjectCard project={PROJECTS[current]} onOpen={setActiveProject} />
        </div>

        <button className="carousel-btn carousel-btn--next" onClick={() => navigate("slide-left")} aria-label="Next">
          &gt;
        </button>
      </div>

      <div className="carousel-dots">
        {PROJECTS.map((_, i) => (
          <button
            key={i}
            className={`carousel-dot ${i === current ? "active" : ""}`}
            onClick={() => {
              setSlideDir(i > current ? "slide-left" : "slide-right");
              setCurrent(i);
            }}
            aria-label={`Go to project ${i + 1}`}
          />
        ))}
      </div>

      {activeProject && (
        <ProjectModal
          project={activeProject}
          onClose={() => setActiveProject(null)}
        />
      )}
      <h1 className="reveal">{"}"}</h1>
    </section>
  );
}